import { Money, MoneyConstructorArgs } from "v2/domain/common/entities/Money";
import Request from "v2/domain/benefitRequest/entities/Request";
import IFindBenefitRequestsResponseContent from "../../interfaces/IFindBenefitRequests";

export default function restoreBenefitRequests({
  employee,
  request,
}: IFindBenefitRequestsResponseContent) {
  return new Request({
    id: request.id,
    employee,
    type: request.type,
    category: request.category,
    state: request.state,
    amount: new Money(
      (request?.input?.amount || { amountInCents: 0 }) as MoneyConstructorArgs
    ),
    initialDate: new Date(request.createdDate),
    approvedDate: request.approvedDate ? new Date(request.approvedDate) : null,
    cancelledDate: request.cancelledDate
      ? new Date(request.cancelledDate)
      : null,
    deniedDate: request.deniedDate ? new Date(request.deniedDate) : null,
    details: request.details,
  });
}
